import { Flex } from "antd";
import { useContacts } from "@/features/contacts/model";
import { ContactsList } from "@/entities/contacts-list";
import { ContactsFilters } from "@/entities/contacts-filters";
import { ContactTabsContent } from "@/entities/contacts-tabs";
import styles from "./styles.module.scss";

export const ContactsDesktop = () => {
  const { state, methods } = useContacts();

  return (
    <Flex className={styles.root} gap={8}>
      <ContactsFilters setFilter={methods.setGroupFilter} groupFilter={state.groupFilter} />
      <ContactsList
        contacts={state.filteredContacts}
        selectedPersonId={state.selectedPersonId}
        setSelectedPersonId={methods.setSelectedPersonId}
      />
      <ContactTabsContent
        selectedPersonId={state.selectedPersonId}
        setSelectedPersonId={methods.setSelectedPersonId}
      />
    </Flex>
  );
};
